const Role = {
  POSLOVODJA: { label: 'Poslovođa', value: 0 },
  VODECIVODOINSTALATER: { label: 'Vodeći vodoinstalater', value: 1 },
  VODOINSTALATERVODOVOD: { label: 'Vodoinstalater - V', value: 2 },
  VODOINSTALATERKANALIZACIJA: {
    label: 'Vodoinstalater - K',
    value: 3,
  },
  POMOCNIRADNIKKANALIZACIJA: {
    label: 'Pomoćni radnik - K',
    value: 4,
  },
  MASINISTA: { label: 'Mašinista', value: 5 },
  DISPECER: { label: 'Dispečer', value: 6 },
  VODECIINZENJERZARAZVOJ: { label: 'Vodeći inženjer za razvoj', value: 7 },
  MAGACIONER: { label: 'Magacioner', value: 8 },
  DIREKTOR: { label: 'Direktor', value: 9 },
  TEHNICKIDIREKTOR: { label: 'Tehnički direktor', value: 10 },
  KNJIGOVODA: { label: 'Knjigovođa', value: 11 },
  REFERENTZAOBRACUNVODE: { label: 'Referent za obračun vode', value: 12 },
  REFERENTOPSTIHPOSLOVA: { label: 'Referent opštih poslova', value: 13 },
  BLAGAJNIK: { label: 'Blagajnik', value: 14 },
  CISTACKURIR: { label: 'Čistač/Kurir', value: 15 },
};

export default Role;
